import { FilePen } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { ToolPart } from "./tool-approvals.ts";

/**
 * One `wiki_write` call in the answer's activity (wiki-collaboration, agent-tools "Activity
 * without content"): how many changes it wrote and the pages and folders it named, never their
 * Markdown (the stored call keeps none). Internal: nothing left ESI, so no outbound row.
 */
export function WikiWriteRow({ part }: { part: ToolPart }) {
  const { t } = useTranslation();
  const operations = (part.input as { operations?: unknown } | undefined)?.operations;
  const names = [
    ...new Set(
      (Array.isArray(operations) ? operations : []).flatMap((op: Record<string, unknown>) => {
        const name = op?.title ?? op?.page ?? op?.path;
        return typeof name === "string" ? [name] : [];
      }),
    ),
  ];
  const count = Array.isArray(operations) ? operations.length : 0;
  const output = part.output as { error?: unknown } | undefined;
  const done = part.state === "output-available" && typeof output?.error !== "string";
  if (part.state === "output-available" && !done) {
    // A refused call wrote nothing: the agent says so in its answer.
    return null;
  }
  return (
    <div className="flex flex-col gap-0.5 py-1 text-xs text-fg-muted">
      <p className="flex min-w-0 items-center gap-1.5">
        <FilePen aria-hidden="true" className="size-3 shrink-0" strokeWidth={2} />
        <span className="font-medium text-fg-secondary tabular-nums">
          {done ? t("tools.wiki.written", { count }) : t("tools.wiki.writing")}
        </span>
      </p>
      {done && names.length > 0 ? <p className="ps-[1.125rem]">{names.join(" · ")}</p> : null}
    </div>
  );
}
